
@switch (schema.type) {
  <!-- Primitive Types -->
  @case ('string') {
    <span>{{ value }}</span>
  }
  @case ('number') {
    <span>{{ value | number }}</span>
  }
  @case ('integer') {
    <span>{{ value | number }}</span>
  }
  @case ('boolean') {
    <span>{{ value ? 'Yes' : 'No' }}</span>
  }
  <!-- Object Type -->
  @case ('object') {
    @if (value) {
      <table >
        <app-dynamic-header [columns]="childColumns"></app-dynamic-header>
        <tbody>
          <tr>
            @for (col of childColumns; track col) {
              <td>
                <app-dynamic-cell
                  [schema]="col.schema"
                  [value]="getValue(value, col.key)">
                </app-dynamic-cell>
              </td>
            }
          </tr>
        </tbody>
      </table>
    }
  }
  @case ('array') {
    @if (value?.length) {
      <table >
        <app-dynamic-header [columns]="childColumns"></app-dynamic-header>
        <tbody>
          @for (item of value; track item) {
            <tr>
              @for (col of childColumns; track col) {
                <td>
                  <app-dynamic-cell
                    [schema]="col.schema"
                    [value]="getValue(item, col.key)">
                  </app-dynamic-cell>
                </td>
              }
            </tr>
          }
        </tbody>
      </table>
    }
  }
  <!-- Array Type -->
  <!-- Fallback -->
  @default {
    <span>{{ value | json }}</span>
  }
}
